import moment from 'moment';
import React, { FunctionComponent, useMemo } from 'react';
import { meetingTasksPageSelectors } from '../../../../../../../../app/page/page-storage/meeting-tasks/meeting-tasks.selectors';

import { taskSimpleSelectors } from '../../../../../../../../app/resource/task-simple/task-simple.selectors';
import { ITaskSimple } from '../../../../../../../../app/resource/task-simple/task-simple.types';
import { ITask } from '../../../../../../../../app/resource/task/task.types';
import { getHoursForDate } from '../../../../../../../../utils/date.utils';
import { useSelect, useSelectWithParams } from '../../../../../../../../utils/selector.utils';
import { CalendarItemHour } from './CalendarItemHour';
import { ICalendarDayViewProps } from './types';

export const CalendarDayView: FunctionComponent<ICalendarDayViewProps> = ({ meetingId, date, userFilter }) => {
  const meetingTasks = useSelect(meetingTasksPageSelectors.selectMeetingTasks);
  const taskIds: ITaskSimple['id'][] = [];
  Object.keys(meetingTasks[meetingId].calendarTasks).forEach((key) => {
    taskIds.push(...meetingTasks[meetingId].calendarTasks[key].active);
    taskIds.push(...meetingTasks[meetingId].calendarTasks[key].done);
  });

  const tasks = useSelectWithParams(taskSimpleSelectors.selectResourcesById, taskIds);
  const hours = useMemo(() => getHoursForDate(date), [date]);

  const tasksPerHour = useMemo(
    () =>
      hours.map(
        (startTime, i) =>
          tasks.filter((task) =>
            hours[i + 1]
              ? moment(task?.dueDate).isSameOrAfter(startTime) && moment(task?.dueDate).isBefore(hours[i + 1])
              : moment(task?.dueDate).isSameOrAfter(startTime),
          ) as ITask[],
      ),
    [hours, tasks],
  );

  return (
    <>
      {hours.map((hour, i) => (
        <div key={`hour-${hour}`} className="calendar-cell" style={{ width: 'auto' }}>
          <CalendarItemHour tasks={tasksPerHour[i]} userFilter={userFilter} />
        </div>
      ))}
    </>
  );
};
